import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Reset scroll to the top of the page every time the route changes.
 * Uses the plain 2-arg form so it works on every browser (iPad Safari
 * silently rejects `behavior: "instant"`).
 */
export default function ScrollToTopOnRouteChange() {
  const { pathname, search } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname, search]);
  return null;
}
